import { MyNaviTypography } from '@/components/Campaign/mynavi/MyNaviUI/MyNaviTypography'
import { MyNaviWishButton } from '@/components/Campaign/mynavi/MyNaviWishButton/MyNaviWishButton'
import { IconCalendarWeek, IconChevronRight } from '@tabler/icons-react'

export type CollegeEvent = {
  eventId: number
  year: number
  /** 例: "7/7(火)" */
  date: string
  /** 例: "千里山キャンパス" */
  campus: string
  isWanted: boolean
  /** OC参加時に押印するスタンプID（null の場合は参加ボタンを非活性化） */
  stampId: number | null
}

export type MyNaviCollegeListProps = {
  collegeName: string
  /** 例: '私立大' | '公立大' | '短大' | '専門学校' */
  collegeType: string
  prefecture: string
  imageUrl?: string
  events: CollegeEvent[]
  totalEvents: number
  /** 「資料請求」を押下したとき。undefined の場合はボタンを disabled にする */
  onBrochureRequest?: () => void
  /** 「イベント情報」を押下したとき。undefined の場合はボタンを disabled にする */
  onEventInfo?: () => void
  onMoreSchedule: () => void
  onOcParticipateRequest: (stampId: number) => void
  onToggleWanted?: (eventId: number) => void
}

export const MyNaviCollegeList = ({
  collegeName,
  collegeType,
  prefecture,
  imageUrl,
  events,
  totalEvents,
  onBrochureRequest,
  onEventInfo,
  onMoreSchedule,
  onOcParticipateRequest,
  onToggleWanted,
}: MyNaviCollegeListProps) => {
  const displayedEvents = events.slice(0, 2)

  return (
    <div
      style={{
        backgroundColor: '#fbfbfb',
        padding: '12px 17px',
        borderBottom: '1px solid #d9d9d9',
      }}
    >
      {/* ヘッダー: 大学情報 + 画像 */}
      <div
        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}
        onClick={onMoreSchedule}
        onKeyDown={(e) => e.key === 'Enter' && onMoreSchedule()}
      >
        <div style={{ flex: 1 }}>
          <MyNaviTypography variant="college-name" className="mb-1">
            {collegeName}
          </MyNaviTypography>
          <MyNaviTypography variant="tiny" as="p">
            {collegeType}　{prefecture}
          </MyNaviTypography>
        </div>
        <div>
          {imageUrl && (
            <img src={imageUrl} alt={collegeName} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          )}
        </div>
      </div>

      {/* 開催日程ボックス */}
      {totalEvents > 0 && (
        <div
          style={{
            border: '1px solid #058bbe',
            borderRadius: '5px',
            padding: '8px 12px',
            marginBottom: '8px',
          }}
        >
          {displayedEvents.map((event) => (
            <div
              key={event.eventId}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '4px 0',
              }}
            >
              <IconCalendarWeek size={24} color="#686868" style={{ flexShrink: 0 }} />
              <div style={{ display: 'flex', flexDirection: 'column', flexShrink: 0 }}>
                <MyNaviTypography variant="micro" className="leading-none">
                  {event.year}年
                </MyNaviTypography>
                <MyNaviTypography variant="caption" className="min-w-[50px]">
                  {event.date}
                </MyNaviTypography>
              </div>
              <MyNaviTypography variant="caption" className="flex-1 self-end">
                {event.campus}
              </MyNaviTypography>
              <MyNaviWishButton isWished={event.isWanted} onClick={() => onToggleWanted?.(event.eventId)} />
            </div>
          ))}

          {totalEvents > 2 && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                marginTop: '4px',
                cursor: 'pointer',
              }}
              onClick={onMoreSchedule}
              onKeyDown={(e) => e.key === 'Enter' && onMoreSchedule()}
              role="button"
              tabIndex={0}
            >
              <span
                style={{
                  fontSize: '10px',
                  fontWeight: 700,
                  color: '#686868',
                  fontFamily: "'Noto Sans JP', sans-serif",
                }}
              >
                別の日程を見る
              </span>
              <IconChevronRight size={18} color="#686868" />
            </div>
          )}
        </div>
      )}

      {/* ボタン行 */}
      <div style={{ display: 'flex', gap: '8px' }}>
        <button
          type="button"
          onClick={onBrochureRequest}
          disabled={!onBrochureRequest}
          style={{
            flex: 1,
            height: '36px',
            borderRadius: '5px',
            backgroundColor: '#e69f67',
            border: 'none',
            cursor: onBrochureRequest ? 'pointer' : 'default',
            color: 'white',
            fontSize: '12px',
            fontFamily: "'Noto Sans JP', sans-serif",
            opacity: onBrochureRequest ? 1 : 0.4,
          }}
        >
          資料請求
        </button>
        <button
          type="button"
          onClick={onEventInfo}
          disabled={!onEventInfo}
          style={{
            flex: 1,
            height: '36px',
            borderRadius: '5px',
            backgroundColor: '#73bdb0',
            border: 'none',
            cursor: onEventInfo ? 'pointer' : 'default',
            color: 'white',
            fontSize: '12px',
            fontFamily: "'Noto Sans JP', sans-serif",
            opacity: onEventInfo ? 1 : 0.4,
          }}
        >
          イベント情報
        </button>
      </div>
    </div>
  )
}
